import { handleRequest } from '@/utils';
import { addDialogue, updateDialogueInfo } from '@/utils/sessionUtils';
import { Intent } from '@/types/intent';
import { INPUT_TYPE } from '../constants';

type HandleRequestCB = (res: any) => void;

const handleClickOrderShortcut = async (content: string, intent: Intent, cb?: HandleRequestCB) => {
  const curPos = addDialogue({
    from: 'user',
    type: 'Msg',
    data: { content: content },
  });


  if (typeof curPos === 'number') {
    // 根据 be 的说法  需要 加  message_text 才会存入  历史消息里
    const params = { ...intent, text: content, message_text: content, input_type: INPUT_TYPE.INPUT_BY_CLICK_ORDER_SHORTCUT };

    handleRequest('postMessage', params, { curPos }).then((res: any) => {
      res && updateDialogueInfo({
        dialogueId: res.dialogue_id,
        dialogueType: res.dialogue_type,
      }, curPos);

      cb && cb(res);
    });
  }
};

export default handleClickOrderShortcut;
